import { TControlName, TUpdaterName } from '@infotech-soe/metaschema';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import {
  FormControlViewModelType,
  InputValue,
} from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import {
  getAreHintsShown,
  getFormControlByName,
  getFormControlForbidden,
  submitForbidden,
} from '../../../store/selectors/form';
import form from '../../../store/slices/form';

import FormControl from './FormControl';

interface Props {
  name: TControlName;
  formId: UniqueId;
  disabled?: boolean;
}

const mapStateToProps = (state: AppState, { formId, name }: Props) => {
  const control = getFormControlByName(state, formId, name);
  return {
    control,
    submitForbidden: submitForbidden(state, formId),
    areHintsShown: getAreHintsShown(state, formId),
    ...(control.type === FormControlViewModelType.BOX &&
      control.collapsible && {
        warning: getFormControlForbidden(state, formId, name),
      }),
  };
};

const mapDispatchToProps = {
  onUpdate: form.update,
  onRunSchemaUpdater: form.runSchemaUpdater,
  onRunSingleUpdater: form.runSingleUpdater,
  onSubmitting: form.submitting,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  {
    onUpdate,
    onRunSchemaUpdater,
    onRunSingleUpdater,
    onSubmitting,
  }: typeof mapDispatchToProps,
  { name: _name, formId, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  formId,
  onChange: (value: InputValue) =>
    onUpdate({ formId, field: sP.control.name, value: value ?? null }),
  onChanged: (value: InputValue) =>
    onRunSchemaUpdater({ formId, field: sP.control.name, value }),
  onRunSingleUpdater: (updaterName?: TUpdaterName) =>
    onRunSingleUpdater({ formId, field: sP.control.name, name: updaterName }),
  onSubmit: (value: InputValue) => {
    onRunSchemaUpdater({ formId, field: sP.control.name, value });
    onUpdate({ formId, field: sP.control.name, value });
    onSubmitting({ formId });
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type TFormControlConnectorProps = ConnectedProps<typeof connector>;

export default connector(FormControl);
